// extracted by mini-css-extract-plugin
module.exports = {"wunnvwv":"wunnvwv","fallAway-wunnvwv":"fallAway-wunnvwv"};